<template>
  <ServicePageLayout
    title="Fire Alarm Report"
    subtitle="รายงานระบบแจ้งเหตุเพลิงไหม้"
    icon="mdi-chart-box-outline"
    icon-color="error"
    breadcrumb="Reports"
  >
    <FireAlarmReportFilter />
    <FireAlarmReportDataTable />
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import FireAlarmReportFilter from '@/components/fire_alarm_report/fire_alarm_report_filter.vue'
import FireAlarmReportDataTable from '@/components/fire_alarm_report/fire_alarm_report_datatable.vue'

export default {
  name: 'FireAlarmReportView',
  components: {
    ServicePageLayout,
    FireAlarmReportFilter,
    FireAlarmReportDataTable
  },
}
</script>
